(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  if (!customElements.get('collection-description-lines')) {
    customElements.define('collection-description-lines', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => {
          this.preview = this.querySelector('.wp-description-preview');
          this.details = this.querySelector('details');
          if (!this.preview || !this.details) return;
          this.measure = () => {
            if (!this.isConnected || this.details.open || !this.preview.clientWidth) return;
            this.details.hidden = this.preview.scrollHeight <= this.preview.clientHeight + 1;
          };
          this.onToggle = () => { if (!this.details.open) this.measure(); };
          this.details.addEventListener('toggle', this.onToggle);
          this.observer = new ResizeObserver(this.measure);
          this.observer.observe(this.preview);
          document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
          this.measure();
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.details?.removeEventListener('toggle', this.onToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
